/**
 * DevExtreme (ui/menu.js)
 * Version: 16.2.5
 * Build date: Mon Feb 27 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 * EULA: https://www.devexpress.com/Support/EULAs/DevExtreme.xml
 */
"use strict";
module.exports = require("./menu/ui.menu");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme/ui/menu.js
// module id = ../../../../devextreme/ui/menu.js
// module chunks = 3